import React from 'react'
import _ from 'underscore'
import { UserCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import TutorAcceptorPosition from './position'
import store from '../../state/store'

class TutorAcceptor extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      accepted_position_ids: []
    }
  }

  onAccept = () => {
    store.emit('tutoring_job:tutor_results:accept', {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutoring_job.id,
      tutoring_job_position_ids: this.props.ui.tutor_acceptor.position_ids,
      notify_tutor: false
    })

    this.onClose()
  }

  onAcceptAndNotify = () => {
    store.emit('tutoring_job:tutor_results:accept', {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutoring_job.id,
      tutoring_job_position_ids: this.props.ui.tutor_acceptor.position_ids,
      notify_tutor: true
    })

    this.onClose()
  }

  onClose = () => {
    store.emit('ui:tutor_acceptor:close')
  }

  render() {
    return (
      <Card className="my-4">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserCheck className="size-4"/>
            Accept Tutor
          </CardTitle>
        </CardHeader>
        <CardContent className="grid gap-1">
          {_.map(this.props.tutoring_job.tutoring_job_positions, (position) => {
            const tutor_subject = _.first(
              _.select(this.props.tutor_result.tutor_subjects, function(tutor_subject) {
                return tutor_subject.subject_id === position.subject_id
              })
            )

            const selected = (this.props.ui.tutor_acceptor.position_ids.includes(position.id)) || (position.tutor_id === this.props.tutor_result.tutor.id)
            const can_toggle = position.tutor_id !== this.props.tutor_result.tutor.id

            return (
              <TutorAcceptorPosition
                key={position.id}
                tutoring_job_position={position}
                tutor_result={this.props.tutor_result}
                tutor_subject={tutor_subject}
                selected={selected}
                can_toggle={can_toggle}
              />
            )
          })}
        </CardContent>
        <CardFooter className="justify-end gap-2">
          <Button variant="outline" size="sm" onClick={this.onClose}>Close</Button>
          <Button variant="success" size="sm" onClick={this.onAccept}>Accept Tutor</Button>
          <Button variant="success" size="sm" onClick={this.onAcceptAndNotify}>Accept & Notify Tutor</Button>
        </CardFooter>
      </Card>
    )
  }
}

export default TutorAcceptor
